import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  MapPin,
  ChevronLeft,
  ChevronRight,
  Award,
  Search,
  Store,
  X,
  Star,
  Briefcase,
  Building
} from "lucide-react";
import "./MerchantListing/listing.css";

import { useDispatch, useSelector } from "react-redux";
import {
  fetchBusinessTypes,
  fetchBusinessCategories,
  fetchBusinessServices,
} from "../features/master/masterThunks";

import { searchMerchantsThunk } from "../features/home/merchantSearchSlice";

const MerchantSearchCards = () => {
  const dispatch = useDispatch();

  const { businessTypes, businessCategories, businessServices } = useSelector(
    (state) => state.master
  );
  const { results, loading } = useSelector(
    (state) => state.merchantSearch
  );

  const merchants = results?.data?.merchants || [];
  const totalPages = results?.totalPages || 1;

  /* ================= STATE ================= */
  const [searchText, setSearchText] = useState("");
  const [activeBusinessType, setActiveBusinessType] = useState(null);
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeService, setActiveService] = useState(null);
  const [page, setPage] = useState(1);

  /* ================= INITIAL LOAD ================= */
  useEffect(() => {
    dispatch(fetchBusinessTypes());
    dispatch(searchMerchantsThunk({ page: 1, limit: 20 }));
  }, [dispatch]);

  /* ================= SEARCH ================= */
useEffect(() => {
  if (!searchText || searchText.trim().length < 2) return;

  const timeout = setTimeout(async () => {
    const value = searchText.trim();

    try {
      // 1️⃣ COUNTRY
      let res = await dispatch(
        searchMerchantsThunk({
          query: value,
          businessTypeId: activeBusinessType,
          businessCategoryId: activeCategory,
          businessServiceId: activeService,
          page: 1,
          limit: 20,
        })
      ).unwrap();

      if (res?.data?.merchants?.length > 0) return;

      // 2️⃣ STATE
      res = await dispatch(
        searchMerchantsThunk({
          stateName: value,
          businessTypeId: activeBusinessType,
          businessCategoryId: activeCategory,
          businessServiceId: activeService,
          page: 1,
          limit: 20,
        })
      ).unwrap();

      if (res?.data?.merchants?.length > 0) return;

      // 3️⃣ DISTRICT
      res = await dispatch(
        searchMerchantsThunk({
          query: value,
          businessTypeId: activeBusinessType,
          businessCategoryId: activeCategory,
          businessServiceId: activeService,
          page: 1,
          limit: 20,
        })
      ).unwrap();

      if (res?.data?.merchants?.length > 0) return;

      // 4️⃣ LOCAL AREA
      await dispatch(
        searchMerchantsThunk({
          localAreaName: value,
          businessTypeId: activeBusinessType,
          businessCategoryId: activeCategory,
          businessServiceId: activeService,
          page: 1,
          limit: 20,
        })
      );

    } catch (err) {
      console.error("Search error:", err);
    }
  }, 400);

  return () => clearTimeout(timeout);
}, [
  searchText,
  activeBusinessType,
  activeCategory,
  activeService,
  dispatch,
]);



  /* ================= BUSINESS TYPE ================= */
// BUSINESS TYPE Click
  const handleBusinessTypeClick = (type) => {
    setActiveBusinessType(type._id);
    setActiveCategory(null);

    // filter merchants
    dispatch(
      searchMerchantsThunk({
        businessTypeId: type._id,
        page: 1,
        limit: 50,
      })
    );

    // fetch categories + services
    dispatch(fetchBusinessCategories(type._id));
    dispatch(fetchBusinessServices(type._id));
  };

  // CATEGORY Click
  const handleCategoryClick = (cat) => {
    setActiveCategory(cat._id);

    dispatch(
      searchMerchantsThunk({
        businessTypeId: activeBusinessType,
        businessCategoryId: cat._id,
        page: 1,
        limit: 50,
      })
    );
  };

  /* ================= RESET ================= */
  const resetFilters = () => {
    setSearchText("");
    setActiveBusinessType(null);
    setActiveCategory(null);
    setActiveService(null);
    setPage(1);

    dispatch(searchMerchantsThunk({ page: 1, limit: 20 }));
  };

  /* ================= PAGINATION ================= */
  const handlePageChange = async (newPage) => {
  setPage(newPage);
  const value = searchText.trim();

  try {
    let res = await dispatch(
      searchMerchantsThunk({
      query: value,
        page: newPage,
        limit: 20,
      })
    ).unwrap();

    if (res?.data?.merchants?.length > 0) return;

    res = await dispatch(
      searchMerchantsThunk({
        stateName: value,
        page: newPage,
        limit: 20,
      })
    ).unwrap();

    if (res?.data?.merchants?.length > 0) return;

    res = await dispatch(
      searchMerchantsThunk({
        query: value,
        page: newPage,
        limit: 20,
      })
    ).unwrap();

    if (res?.data?.merchants?.length > 0) return;

    await dispatch(
      searchMerchantsThunk({
        localAreaName: value,
        page: newPage,
        limit: 20,
      })
    );
  } catch (err) {
    console.error(err);
  }
};


  return (
    <div className="merchant-main-wrapper">
      <div className="container-search">

        {/* ================= SEARCH BAR ================= */}
        <div className="search-header">
          <div className="search-bar-wrapper mt-4">
            <Search className="search-icon" size={20} />
            <input
              type="text"
              className="modern-search-input"
              placeholder="Search your by district name......."
              value={searchText}
             onChange={(e) => setSearchText(e.target.value)}
            />
            {searchText && (
              <X
                className="clear-search"
                size={18}
                onClick={resetFilters}
              />
            )}
          </div>
        </div>

        {/* ================= FILTER TABS ================= */}
        <div className="filter-section">
          <div className="scroll-container">

            {activeBusinessType && (
              <button className="category-chip reset-chip" onClick={resetFilters}>
                <X size={16} /> Clear All
              </button>
            )}

            {/* BUSINESS TYPE */}
{!activeBusinessType && (
        <div className="category-scroll-wrapper">
          {businessTypes?.map((type) => (
            <button
              key={type._id}
              className={`category-chip`}
              onClick={() => handleBusinessTypeClick(type)}>
              <Store size={20} />
              <span>{type.name}</span>
            </button>
          ))}
        </div>
      )}

      {/* 🔥 SHOW CATEGORIES + SERVICES WHEN BUSINESS TYPE IS SELECTED */}
      {activeBusinessType && (
        <>
          {/* Business Categories */}
          {businessCategories?.length > 0 && (
            <div className="category-scroll-wrapper">
              {businessCategories.map((category) => (
                <button
                  key={category._id}
                  className={`category-chip ${
                    activeCategory === category._id ? "active-chip" : ""
                  }`}
                  onClick={() => handleCategoryClick(category)}
                >
                  <Store size={20} />
                  <span>{category.name}</span>
                </button>
              ))}
            </div>
          )}

          {/* Business Services */}
        {businessServices?.length > 0 && (
  <div className="category-scroll-wrapper mt-2">  
    {businessServices.map((service) => (
      <button
        key={service._id}
        className="category-chip"
        onClick={() => {
          setActiveService(service._id);

dispatch(
  searchMerchantsThunk({
    businessTypeId: activeBusinessType,
    businessCategoryId: service._id,
    page: 1,
    limit: 50,
  })
);

        }}
      >
        <Store size={20} />
        <span>{service.name}</span>
      </button>
    ))}
  </div>
)}

        </>
      )}
          </div>
        </div>

        {/* ================= RESULTS ================= */}
        {loading ? (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        ) : merchants.length === 0 ? (
          <div className="empty-state">
            <Store size={48} />
            <p>No merchants found matching your criteria.</p>
          </div>
        ) : (
          <div className="merchants-grid">
            {merchants.map((merchant) => (
              <Link
                key={merchant.merchantId}
                to={`/merchant-detail/${merchant.merchantId}`}
                className="merchant-card"
              >
                <div className="image-wrapper">
                  {merchant.businessLogo ? (
                    <img
                      src={`${process.env.REACT_APP_IMAGE_BASE_URL}${merchant.businessLogo}`}
                      alt={merchant.businessName}
                      className="business-image"
                      loading="lazy"
                      decoding="async"
                    />
                  ) : (
                    <div className="no-logo-placeholder">
                      <Building size={48} color="#6154A4" />
                    </div>
                  )}

                  {merchant.overview?.rating > 0 && (
  <div className="rating-badge">
    <Star size={12} />
    <span>{merchant.overview.rating}</span>
  </div>
)}

                </div>

                <div className="card-body">
                  <span className="type-tag">{merchant.businessType}</span>
                  <h3 className="business-name">{merchant.businessName}</h3>

                  <div className="meta-info">
                    <div className="info-item">
                      <MapPin size={14} />
                      <span>
                        {merchant.localArea}, {merchant.district}
                      </span>
                    </div>

                    <div className="info-item">
                      <Award size={14} />
                      <span>{merchant.quickInfo?.speciality || "N/A"}</span>
                    </div>

                    <div className="info-item">
                      <Briefcase size={14} />
                      <span>
                        {merchant.overview?.experienceInYears || "N/A"} Years
                      </span>
                    </div>
                  </div>

                  <button className="view-details-btn">View Details</button>
                </div>
              </Link>
            ))}
          </div>
        )}

        {/* ================= PAGINATION ================= */}
        {totalPages > 1 && (
          <div className="pagination">
            <button
              className="pag-nav"
              onClick={() => handlePageChange(page - 1)}
              disabled={page === 1}
            >
              <ChevronLeft size={20} />
            </button>

            <span className="page-indicator">
              Page {page} of {totalPages}
            </span>

            <button
              className="pag-nav"
              onClick={() => handlePageChange(page + 1)}
              disabled={page === totalPages}
            >
              <ChevronRight size={20} />
            </button>
          </div>
        )}
      </div>
      <style jsx>{`
      :root {
  --p-color: #6052a5;
  --p-dark: #4a3f85;
  --bg-subtle: #f8fafc;
  --white: #ffffff;
  --text-main: #1e293b;
  --text-muted: #64748b;
  --shadow-sm: 0 2px 4px rgba(0,0,0,0.05);
  --shadow-md: 0 10px 15px -3px rgba(0,0,0,0.1);
  --radius: 12px;
}

.merchant-main-wrapper {
  background-color: var(--bg-subtle);
  min-height: 100vh;
  padding: 2rem 1rem;
  font-family: 'Inter', sans-serif;
}

/* Header & Search */
.search-header {
  text-align: center;
  max-width: 700px;
  margin: 2rem auto 2rem;
}

.main-title {
  font-size: 2.25rem;
  font-weight: 800;
  color: var(--text-main);
  letter-spacing: -0.025em;
  margin-bottom: 1.5rem;
}

.search-bar-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background: var(--white);
  padding: 0.5rem 1.25rem;
  border-radius: 50px;
  box-shadow: var(--shadow-md);
  border: 1px solid rgba(0,0,0,0.15);
}

.modern-search-input {
  width: 100%;
  border: none;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  outline: none;
}

.search-icon { color: var(--p-color); }

/* Horizontal Scroll Filters */
.filter-section {
  margin-bottom: 2rem;
}

.scroll-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 10px 5px;
  width: 100%;
}

/* The chip groups are flex children of .scroll-container; they need to
   wrap onto multiple rows themselves instead of scrolling, and take the
   full row width so wrapping happens within the container instead of
   chips overflowing off the edge. */
.scroll-container .category-scroll-wrapper {
  overflow: visible;
  flex-wrap: wrap;
  min-width: 0;
  width: 100%;
  flex-shrink: 1;
  padding: 0;
}

.category-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 18px;
  background: var(--white);
  border: 1px solid #e2e8f0;
  border-radius: 100px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s;
  color: var(--text-main);
  font-weight: 500;
}

.category-chip:hover {
  border-color: var(--p-color);
  background: #f5f3ff;
}

.category-chip.active {
  background: var(--p-color);
  color: white!important;
  border-color: var(--p-color);
}

.reset-chip { background: #fee2e2; color: #dc2626; border: none; }

/* Grid Layout */
.merchants-grid {
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
}

/* Merchant Card */
.merchant-card {
  background: var(--white);
  border-radius: var(--radius);
  overflow: hidden;
  text-decoration: none;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s;
  border: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
}

.merchant-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1);
}

.image-wrapper {
  position: relative;
  height: 170px;
  background: #f8fafc;
}

.image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding:0.6rem;
}

.rating-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: #4A3F85;
  backdrop-filter: blur(4px);
  padding: 4px 8px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 700;
  font-size: 0.75rem;
  color: #ffffffff;
}

.card-body {
  padding: 0 1.25rem 1.25rem;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.type-tag {
  font-size: 0.7rem;
  text-transform: uppercase;
  font-weight: 700;
  color: var(--p-color);
  letter-spacing: 0.05em;
  margin-bottom: 0.5rem;
}

.business-name {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-main);
  margin-bottom: 0.75rem;
  line-height: 1.2;
}

.meta-info {
  margin-top: auto;
  margin-bottom: 0.2rem;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  color: var(--text-muted);
  margin-bottom: 4px;
}

.view-details-btn {
  width: 100%;
  padding: 0.45rem;
  background: var(--p-color);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.view-details-btn:hover { background: var(--p-dark); }

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  margin-top: 4rem;
}

.pag-nav {
  padding: 10px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.2s;
}

.pag-nav:disabled { opacity: 0.3; cursor: not-allowed; }
.pag-nav:not(:disabled):hover { border-color: var(--p-color); color: var(--p-color); }

/* Responsive Adjustments */
@media (max-width: 640px) {
  .main-title { font-size: 1.75rem; }
  .merchants-grid { grid-template-columns: 1fr; }
  .merchant-card { margin: 0 10px; }
}

@media (max-width: 768px) {
.merchant-main-wrapper {
  padding:0rem 1rem 2rem 1rem;

}
}
/* Wrapper */
.image-wrapper {
  position: relative;
  width: 100%;
  height: 180px;
  border-radius: 16px;
  overflow: hidden;
  background: #f8f9fb;
}

/* Dark / gradient overlay */
.image-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.05) 0%,
    rgba(0, 0, 0, 0.35) 100%
  );
  z-index: 1;
  pointer-events: none;
}

/* Image */
.image-wrapper .business-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: relative;
  z-index: 0;
  background: white;
}

/* Fallback icon container */
.image-wrapper .no-logo-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    #f4f6ff,
    #eef2ff
  );
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Icon polish */
.image-wrapper .no-logo-placeholder svg {
  opacity: 0.85;
}

/* Hover enhancement (optional) */
.search-business-card:hover .image-overlay {
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.08) 0%,
    rgba(0, 0, 0, 0.45) 100%
  );
}

/* Responsive Adjustments */
@media (max-width: 640px) {
  .main-title { 
    font-size: 1.5rem; 
  }
  
  .merchants-grid { 
    /* This creates 2 equal columns */
    grid-template-columns: repeat(2, 1fr); 
    gap: 0.75rem; /* Reducing gap slightly for smaller screens */
  }

  .merchant-card { 
    margin: 0; /* Remove side margins to allow cards to fit */
  }

  /* Adjusting card elements for smaller real estate */
  .image-wrapper {
    height: 120px; /* Shorter images so cards aren't too tall */
  }

  .business-name {
    font-size: 0.8rem; /* Smaller text for 2-column layout */
  }
  
  .card-body {
    padding: 0.75rem; /* Less padding inside the card */
  }

  .info-item span {
    font-size: 0.65rem; /* Smaller meta text */
  }
  
  .view-details-btn {
    font-size: 0.7rem;
    padding: 0.25rem;
  }

  .rating-badge {
      padding: 2px 4px;
      font-size: 0.55rem;
  }
}
`}</style>
    </div>
  );
};

export default MerchantSearchCards;